import { render, staticRenderFns } from "./HRPostContent.vue?vue&type=template&id=33f77bb2&scoped=true&"
import script from "./HRPostContent.vue?vue&type=script&lang=js&"
export * from "./HRPostContent.vue?vue&type=script&lang=js&"
import style0 from "./HRPostContent.vue?vue&type=style&index=0&id=33f77bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f77bb2",
  null
  
)

export default component.exports